import { supabaseClient } from "@/lib/supabase";
import type { OrganisationT } from "@/types/database/organisations";
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
// Define the Organisation type based on the database schema

// Query function to fetch organisations
export async function fetchOrganisations(): Promise<OrganisationT[]> {
	const { data, error } = await supabaseClient
		.from("organisations")
		.select("*");

	if (error) throw error;
	return data;
}

// Query options for organisations
export const organisationsQueryOptions = (): UseQueryOptions<
	OrganisationT[],
	Error
> => ({
	queryKey: ["organisations"],
	queryFn: fetchOrganisations,
});

// Hook to select organisations
export function useSelectOrganisations() {
	return useQuery<OrganisationT[], Error>(organisationsQueryOptions());
}
